import React, { useState } from "react";
import { Button, Typography } from "antd";
import { DeleteOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import BaseTable from "../../../../components/BaseTable";
import Column from "../../../../components/Column";
import Row from "../../../../components/Row";
import AppInputText from "../../../../components/AppInputText/AppInputText";
import ActionHeader from "../../../../components/ActionHeader";
import { BaseModel } from "../../../../../infrastructure/model/base/BaseModel";
import {
  deleteUoMUseCase,
  getListUoMUseCase,
  insertUoMUseCase,
} from "../../../../../applications/useCase/ApiUseCase/UomApiUseCase";
import usePageState from "../../../../hooks/usePageState";
import { useGlobalState } from "../../../../context/AppGlobalContext";
import useConfirmAction from "../../../../hooks/useConfirmAction";

function UnitManager(){
  const [unitName, setUnitName] = useState<string>("");
  const [itemSelected, setItemSelected] = useState<BaseModel>();
  const { dialog: confirmDeleteDialog, confirm: confirmDelete } = useConfirmAction({
    onConfirm: deleteUOM,
  });
  const { isLoading, setLoading, showError, showSuccess } = usePageState();
  const { listUoM: dataTable, updateListUoM: setDataTable } = useGlobalState();

  async function getListData() {
    const dataRes = await getListUoMUseCase({
      setLoading,
      showError,
      showSuccess,
    });
    setDataTable(dataRes);
  }

  async function deleteUOM() {
    if (!itemSelected?.id) return;
    const dataRes = await deleteUoMUseCase({
      id: itemSelected.id,
      setLoading,
      showError,
      showSuccess,
    });
    if (dataRes) {
      setDataTable(dataTable.filter((e) => e.id !== itemSelected.id));
      setItemSelected(undefined);
    }
  }

  async function insetData(request: BaseModel) {
    const result = await insertUoMUseCase({
      param: request,
      setLoading,
      showError,
      showSuccess,
    });
    if (result) {
      setDataTable([result, ...dataTable]);
      setUnitName("");
    }
  }

  return (
    <Column className="h-100 w-100 p-3">
      <Column className="gap-2 pb-2">
        <Row className="w-100 gap-2">
          <AppInputText
            orientation="col"
            label="Tên đơn vị tính"
            additionProps={{
              placeholder: "kg, cốc, chiếc, ...",
            }}
            isRequired
            currentValue={unitName}
            onTextChange={(e) => setUnitName(e)}
          />
          <Button
            type="primary"
            htmlType="submit"
            icon={<PlusOutlined />}
            style={{ marginTop: "19px" }}
            disabled={unitName?.trim()?.length === 0}
            onClick={() => insetData({ id: 0, name: unitName })}
          >
            Thêm đơn vị tính
          </Button>
        </Row>

        {/* Danh sách Table */}
        <ActionHeader
          rowCount={dataTable?.length}
          actions={[
            {
              icon: <ReloadOutlined />,
              userClick: getListData,
              title: "Làm mới",
              isNormal: true,
            },
            {
              icon: <DeleteOutlined />,
              userClick: confirmDelete,
              title: "Xóa",
              disabled: !itemSelected?.id,
              isNormal: true,
              color: "danger",
            },
          ]}
        />
      </Column>

      <BaseTable
        dataSource={dataTable}
        rowSelection={{
          type: "radio",
          selectedRowKeys: itemSelected?.id ? [itemSelected.id] : [],
          onSelect(record) {
            setItemSelected(record);
          },
        }}
        loading={isLoading}
        columns={[
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: "20%",
          },
          {
            title: "Tên đơn vị tính",
            dataIndex: "name",
            key: "name",
          },
        ]}
        rowKey="id"
      />
      {confirmDeleteDialog}
    </Column>
  );
};

export default UnitManager;
